// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24ZHU","toggleWrap":"styles_toggleWrap__2kjF8","content":"styles_content__1U4SV","selectAreaCode":"styles_selectAreaCode__3BJJ5"};